var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosedCaptioning = function SvgClosedCaptioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    fill: "none",
    viewBox: "0 0 24 21"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.89,
    height: 18.25,
    x: 1,
    y: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 3,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.98 8.63h1.93V7.3a1.3 1.3 0 0 0-1.28-1.32H5.77c-.71 0-1.29.6-1.29 1.32v5.31c0 .73.58 1.33 1.29 1.33h3.86c.7 0 1.28-.6 1.28-1.33v-1.33H8.98v.67H6.41V7.97h2.57v.66ZM17.98 8.63h1.93V7.3a1.3 1.3 0 0 0-1.29-1.32h-3.85c-.72 0-1.29.6-1.29 1.32v5.31c0 .73.57 1.33 1.29 1.33h3.85c.72 0 1.29-.6 1.29-1.33v-1.33h-1.93v.67h-2.57V7.97h2.57v.66Z"
  })));
};
export default SvgClosedCaptioning;